import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function OutWorkSection() {
    const { t } = useTranslation();
    UseScrollAnimation();

    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col py-[20px] mx-auto w-fit">
                <div className="js-scroll fade-btm flex items-center gap-[5px] capitalize">
                    <span className="h-[2px] w-[25px] bg-[#A0642E]"></span>
                    <div className="font-bold text-white">{t("OUR WORKS")}</div>
                </div>
                <div className="js-scroll fade-top font-bold text-white text-[35px]">{t("Recent Works")}</div>
            </div>
            <div className="container flex flex-col gap-[20px]">
                <div className="flex flex-wrap gap-[10px]">
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1 (1).JPG")} alt="" />
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1 (2).JPG")} alt="" />
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1 (3).JPG")} alt="" />
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1 (4).JPG")} alt="" />
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1 (5).JPG")} alt="" />
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1 (1).PNG")} alt="" />
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1 (6).JPG")} alt="" />
                    <img className="w-100 js-scroll fade-top w-[24%] h-[350px] rounded-[4px]" src={require("../../assets/image/1-111.png")} alt="" />
                </div>
                <Link className="js-scroll fade-btm bg-[#016E82] mx-auto text-white px-[40px] py-[8px] rounded font-bold capitalize" to={"/portfolio"}>{t("View More Works")}</Link>
            </div>
        </section>
    );
}
